/**
 * 对时间-秒做格式化处理，输入一定格式的时间字符串
 */
export function formatSecond (sec, useCn = false) {
    let second = parseInt(sec);
    if (Number.isNaN(second)) {
        throw new Error('参数不能被转换成有效的整数');
    }
    let str = '';
    let langMap = {
        default: {
            h: ':',
            m: ':',
            s: ''
        },
        cn: {
            h: '小时',
            m: '分',
            s: '秒'
        }
    };
    let clo = useCn ? langMap.cn : langMap.default;
    if (second) {
        let h = Math.floor(second / 3600);
        let m = Math.floor(second % 3600 / 60);
        let s = Math.floor(second % 60);
        str = `${h ? h + clo.h : ''}${m < 10 && !useCn ? '0' + m : m}${clo.m}${s < 10 && !useCn ? '0' + s : s}${clo.s}`;
    } else {
        str = `00${clo.m}00${clo.s}`;
    }
    return str;
}

export function formatDate (date, fmt) {
    if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
    }
    let o = {
        'M+': date.getMonth() + 1,
        'd+': date.getDate(),
        'h+': date.getHours(),
        'm+': date.getMinutes(),
        's+': date.getSeconds()
    };
    for (let k in o) {
        if (new RegExp(`(${k})`).test(fmt)) {
            let str = o[k] + '';
            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : padLeftZero(str));
        }
    }
    return fmt;
};

function padLeftZero (str) {
    return ('00' + str).substr(str.length);
}

// format = 'yyyy-MM-dd hh:mm:ss'
export function dateFormat (timestamp, format) {
    let date = new Date(timestamp);
    var o = {
        'y+': date.getFullYear(),
        'M+': date.getMonth() + 1, // 月份 "d+": value.getDate(), // 日
        'd+': date.getDate(),
        'h+': date.getHours(), // 小时 "m+": value.getMinutes(), // 分 "s+": value.getSeconds(), // 秒
        'm+': date.getMinutes(),
        's+': date.getSeconds()
    };
    if (/(y+)/.test(format)) {
        format = format.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
    }
    for (var k in o) {
        if (new RegExp('(' + k + ')').test(format)) {
            format = format.replace(
                RegExp.$1,
                RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length)
            );
        }
    }
    return format;
}

export function compareDateData (property, bol) { // property需要排序传入的key,bol为true时是升序，false为降序
    return function (a, b) {
        var value1 = a[property];
        var value2 = b[property];
        if (bol) {
            return Date.parse(value1) - Date.parse(value2);
        } else {
            return Date.parse(value2) - Date.parse(value1);
        }
    };
}



// WEBPACK FOOTER //
// ./src/utils/date.js